"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    leftNavigation: {
        navigationAriaLabel: 'Button, {{selected}}, {{optionName}}',
        selected: 'selected',
        notSelected: 'not selected',
    },
};
